// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>69</span>&nbsp;&nbsp;The proud have smeared me with lies,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but I will keep your commandments with my whole heart.<br> </p> </div></div>";
// Exports
module.exports = code;